import datetimeFormats from "./dateTime";
const config = {
	datetimeFormats,
	fallbackLocale: "nl"
};
export default () => config;
